<template>
    <div>
        <hts-form-select
            ref="selectCooperator"
            v-model="cValue"
            v-model:text="cText"
            :query="findCooperator"
            :filterable="true"
            :clearable="clearable"
            :label="label"
            :placeholder="placeholder"
            :required="required"
            :disabled="disabled"
            :readonly="readonly"
            :selected-multiple="dataMultiple"
            :multiple="multiple"
            :prop="prop"
            :name="nameSelect"
            key-id="_id"
            :key-label="keyLabel"
            :key-sub-label="keySubLabel"
            :creatable="CCreatable"
            :confirm-change="confirmChange"
            :title-confirm="titleConfirm"
            :detail-confirm="detailConfirm"
            :color="color"
            @create-new="createCooperator"
            @change="handleChange">
            <template #default="{ item }">
                <slot :item="item" />
            </template>
        </hts-form-select>

        <AddCooperator
            v-if="checkPermission(layoutPermissions['partner_add'])"
            ref="addCooperator"
            @newPartner="handleChangeCreateCooperator" />
    </div>
</template>

<script lang="ts" setup>
import AddCooperator from '../../pages/trucker-[id]/partner/-components/add.vue'
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'
const { $searchObjects } = useNuxtApp()

const props = defineProps({
  modelValue: {
    type: [Array, String],
    default: () => ''
  },
  prop: {
    type: String,
    default: ''
  },
  nameSelect: {
    type: String,
    default: ''
  },
  multiple: {
    type: Boolean,
    default: false
  },
  dataMultiple: {
    type: [Array, Object],
    default: () => []
  },
  required: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    default: ''
  },
  label: {
    type: String as PropType<string | null>,
    default: () => $t('labels.findPartner')
  },
  placeholder: String as PropType<string | null | undefined>,
  typeCooperator: {
    type: [String, Array],
    default: ''
  },
  creatable: Boolean,
  disabled: Boolean,
  readonly: Boolean,
  clearable: {
    type: Boolean,
    default: true
  },
  confirmChange: {
    type: Boolean,
    default: false
  },
  titleConfirm: {
    type: String
  },
  detailConfirm: {
    type: String
  },
  items: {
    type: Array
  },
  keyLabel: {
    type: String,
    default: 'name'
  },
  keySubLabel: {
    type: String,
    default: ''
  },
  color: String as PropType<string | undefined | null>,
  notYetJoinSystem: { type: Boolean, default: false } // partner chưa tham gia hệ thống
})

const emits = defineEmits(['update:modelValue', 'update:name', 'click', 'change'])

const { modelValue, name, required, multiple, creatable, typeCooperator, disabled, items, notYetJoinSystem } = toRefs(props)

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const addCooperator = ref()
const selectCooperator = ref()

const availableTypes = computed(() => {
  if (typeof typeCooperator.value === 'string') {
    return [typeCooperator.value]
  }
  return typeCooperator.value
})

const findCooperator = async (s: string) => {
  const api = $url.partner.find

  const query = {} as { [key: string]: any }
  if (notYetJoinSystem.value) {
    query.notYetJoinSystem = true
  }

  if (availableTypes.value) {
    query.type = availableTypes.value
  }

  query.key = s

  const res = await $api(api, {
    query
  })

  const dataItems = items?.value ? $searchObjects(items.value, 'name', s, { i: true }) : []

  const resData: any = res?.data.value
  if (resData?.success) {
    return [...dataItems, ...resData.data]
  }
  return dataItems
}

const cText = computed({
  get () {
    return name.value || ''
  },
  set (val: any) {
    emits('update:name', val)
  }
})

const CCreatable = computed(() => {
  if (!creatable?.value) {
    return false
  }
  if (!checkPermission(layoutPermissions.partner_add)) {
    return false
  }
  return true
})

const createCooperator = () => {
  if (!creatable?.value) {
    return null
  }
  if (!availableTypes.value.length) {
    return
  }

  if (!checkPermission(layoutPermissions.partner_add)) {
    process.client && $toast().error($t('labels.vendorPriceModule.notPermission'))
    return null
  }

  if (addCooperator.value) {
    if (selectCooperator.value) {
      selectCooperator.value.hide()
    }

    addCooperator.value.open(availableTypes.value[0])
  }
}

const handleChange = (val: any) => {
  emits('change', val)
}
const handleChangeCreateCooperator = (data: any) => {
  if (!multiple.value) {
    if (data && data._id) {
      cValue.value = data._id
      cText.value = data.name || ''
      emits('change', [data])
    }
  }
}
</script>
